import React from 'react';

export type FullStoryContextProps = {
    ready: boolean;
};

const FullStoryContext = React.createContext<FullStoryContextProps>({
    ready: false,
});

export default FullStoryContext;
